import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    form: 'rounded-xs bg-brand-2',
    input: 'b-0 h-12 |bg-transparent',
    submit: 'pl-3'
  },
  defaultSubmitPosition: 'start',
  iconNameClear: 'clear-filled'
} satisfies RecursivePartial<VfConfig['searchBar']>
